import type {
  ServiceabilityAddressSuggestion,
  ServiceabilityV3RequestServiceAddress,
  ServiceabilityV3Response,
} from "@/types/serviceability";
import { postJson } from "./shared";

interface GetServiceabilityV3ByElocIdParams {
  elocId: ServiceabilityAddressSuggestion["elocId"];
  serviceAddress?: never;
}

interface GetServiceabilityV3ByServiceAddressParams {
  elocId?: never;
  serviceAddress: ServiceabilityV3RequestServiceAddress;
}

export type GetServiceabilityV3Params = (
  | GetServiceabilityV3ByElocIdParams
  | GetServiceabilityV3ByServiceAddressParams
) & {
  signal?: AbortSignal;
};

export async function getServiceabilityV3({
  elocId,
  serviceAddress,
  signal,
}: GetServiceabilityV3Params): Promise<ServiceabilityV3Response> {
  if (serviceAddress) {
    return postJson<ServiceabilityV3Response>({
      path: "/serviceability/v3",
      body: {
        AccountNumber: "",
        serviceAddress,
        tenantInfo: null,
      },
      signal,
    });
  }

  if (!elocId) {
    throw new Error("ELOC ID or serviceAddress is required");
  }

  return postJson<ServiceabilityV3Response>({
    path: "/serviceability/v3",
    body: {
      AccountNumber: "",
      LocationId: elocId,
      tenantInfo: null,
    },
    signal,
  });
}
